module.exports = __webpack_public_path__ + "static/billboardLogo-95fbb2007920b5460b8103a34523d54d.png";